import * as React from 'react'
import useTranslation from '../../hooks/useTranslation'

import('./QuickBetStyles.scss')   



// the QuickBet container contains a button that defines the state of the matchlist container:
// expanded matchlist with bets or default matchlist without bets but with ranking
const QuickBetPresentation = (props:any) => {
    const quickBettingText = useTranslation('Matchlist_quickBetting');
    return (
        <div className={"quickBetting "}>
            <span>{quickBettingText}</span>
            <div
                className={`quickBettingSlider ${setActive(props.quickBetsState)}`}
                onClick={(event:any) => {props.toggleQuickBetting(props.id); }}
            />
        </div>
    )
}

const setActive:any = (value:boolean) => value ? 'active' : ''

export default QuickBetPresentation
